/* ============================================================
   reveal.js  —  shared scroll-in animation
   ------------------------------------------------------------
   WHAT THIS DOES:
   Any element with the attribute  data-reveal  starts slightly
   faded + shifted down (see theme-base.css). When it scrolls
   into view this script adds the class  is-revealed  which
   animates it to its final position. Each element animates only
   once. Optional per-element stagger:  data-reveal-delay="120"
   (milliseconds).

   No framework, no dependencies. Loaded with `defer` so it
   never blocks rendering. ~0.8KB.
   ============================================================ */
(function () {
  var nodes = document.querySelectorAll('[data-reveal]');
  if (!nodes.length) return;

  // Users who prefer reduced motion: show everything immediately.
  var reduce = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) {
    nodes.forEach(function (el) { el.classList.add('is-revealed'); });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var delay = parseInt(el.getAttribute('data-reveal-delay'), 10) || 0;
      setTimeout(function () { el.classList.add('is-revealed'); }, delay);
      io.unobserve(el); // animate once, then stop watching
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });

  nodes.forEach(function (el) { io.observe(el); });
})();
